// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"859b1fe3","804":"7158b195"}[chunkId] + ".chunk.css";
};